/**
 * Загружает все widget-темы в DOM admin'а одним <link>. Темы скоупаны
 * селекторами [data-inbx-widget][data-type=X][data-theme=Y], поэтому
 * не влияют на admin UI вне preview-блоков.
 *
 * Также подгружает manifest темам через JSON для UI селектора.
 * Кэшируется в module-scope (один раз на сессию).
 */

export interface ThemeMeta {
  id: string;
  kind: 'chat' | 'form' | 'survey' | 'promo';
  name: string;
  description: string;
}

let themesPromise: Promise<ThemeMeta[]> | null = null;
let cssInjected = false;

export async function ensureThemesLoaded(): Promise<ThemeMeta[]> {
  if (!cssInjected) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/api/widget-themes.css';
    link.setAttribute('data-inbx-admin-themes', 'true');
    document.head.appendChild(link);
    cssInjected = true;
  }
  if (!themesPromise) {
    themesPromise = fetch('/api/widget-themes.json')
      .then((r) => r.json() as Promise<ThemeMeta[]>)
      .catch(() => []);
  }
  return themesPromise;
}

export function themesByKind(themes: ThemeMeta[], kind: ThemeMeta['kind']): ThemeMeta[] {
  return themes.filter((t) => t.kind === kind);
}
